<div class="filters-and-sort-container">
  <div class="filters-container">
    <mat-form-field appearance="fill">
      <mat-label>Select an option</mat-label>
      <mat-select [(value)]="selectedFilter">
        <mat-option>None</mat-option>
        <mat-option value="referenceId">Reference ID</mat-option>
        <mat-option value="emailAddress">Email Address</mat-option>
        <mat-option value="phoneNumber">Phone Number</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Search Term</mat-label>
      <input matInput>
    </mat-form-field>
    <button mat-raised-button color="primary" type="submit">Search</button>
  </div>
  <div class="sort-container">
    <mat-form-field appearance="fill">
      <mat-label>Sort By</mat-label>
      <mat-select [(value)]="selectedSort">
        <mat-option value="referenceId">Archived Date</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="result-container">
  <div class="headers-container">
    <div class="email">
      <span class="material-symbols-outlined">email</span>email&#64;email.com
    </div>
    <div class="table-headings-container">
      <div class="table-heading email-sent">Email Sent</div>
      <div class="table-heading link-clicked">Link Clicked</div>
      <div class="table-heading customer-valid">Customer Valid</div>
      <div class="table-heading completed">Completed</div>
      <div class="table-heading archived">Archived</div>
    </div>
  </div>

  <div class="details-container">
    <div class="applicant-soa-info-container">
      <div class="top-div">
        <div class="user-data reference-id"><b>Reference ID: </b>00000000</div>
        <div class="user-data applicant-name"><b>Name: </b>Jeremy Hammersmit</div>
      </div>
      <div class="bottom-div">
        <div class="user-data applicant-zip"><b>Zip Code: </b>13112</div>
        <div class="user-data registered-status"><b>Registered: </b>No</div>
      </div>
    </div>
    <div class="application-details">
      <div class="table-data email-sent-date">01/22/2022</div>
      <div class="table-data table-icon">
        <span class="material-symbols-outlined">launch</span>
      </div>
      <div class="table-data table-icon">
        <span class="material-symbols-outlined">hourglass_empty</span>
      </div>
      <div class="table-data table-icon">
        <span class="material-symbols-outlined">edit</span>
      </div>
      <div class="table-data table-icon">
        <span class="material-symbols-outlined">lock</span>
      </div>
    </div>
  </div>

</div>
